module.exports = __webpack_public_path__ + "static/media/boat-img-26.55914328.jpg";